import { useEffect, useState } from "react";

const ACTION_LABEL = {
  "member.create": "Created member",
  "member.update": "Updated member",
  "member.erase": "Erased member (GDPR)",
  "member.data_export": "Exported member data (SAR)",
};

export function AuditLog({ chapterId, canManage }) {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    fetch(`/api/chapters/${chapterId}/audit`, { credentials: "same-origin" })
      .then((res) => (res.ok ? res.json() : { entries: [] }))
      .then((d) => setEntries(d.entries));
  }, [chapterId]);

  if (!canManage) return <p className="muted">The audit log is available to the committee.</p>;
  if (entries === null) return <p className="muted">Loading audit log…</p>;

  return (
    <div className="section">
      <div className="section-head"><h3>Audit log · {entries.length}</h3></div>
      <p className="muted" style={{ fontSize: 13, marginTop: 0 }}>
        Accountability trail for actions on personal data (last 200).
      </p>
      {entries.length ? (
        <table className="tbl">
          <thead><tr><th>When</th><th>Who</th><th>Action</th><th>Subject</th></tr></thead>
          <tbody>
            {entries.map((e) => (
              <tr key={e.id}>
                <td className="muted" style={{ whiteSpace: "nowrap" }}>
                  {e.at ? e.at.slice(0, 16).replace("T", " ") : "—"}
                </td>
                <td>{e.actor_email || "—"}</td>
                <td>{ACTION_LABEL[e.action] || e.action}</td>
                <td className="muted">{e.detail || (e.target_id ? `#${e.target_id}` : "—")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="empty">No audit entries yet.</p>
      )}
    </div>
  );
}
